import { useEffect, useCallback } from "react";
import Modal from "react-modal";

const ModalComponent = ({ modalIsOpen, setModalIsOpen, children, top, bottom }) => {
    const customStyles = {
        overlay: {
            position: "fixed",
            zIndex:"100",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            cursor: "pointer",
        },
        content: {
            cursor: "auto",
            position: "fixed",
            top: top,
            bottom: bottom,
            overflow: "hidden",
            outline: "none",
            WebkitOverflowScrolling: "touch",
            zIndex: "110",
        },
    };

    const closeModal = useCallback(() => {
        setModalIsOpen(false);
    }, [setModalIsOpen]);

    useEffect(() => {
        if (modalIsOpen) {
            document.body.style.overflow = "hidden";

            return () => {
                document.body.style.overflow = "auto";
            };
        }
    }, [modalIsOpen]);

    return (
        <Modal
            className="position-x"
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
        >
            {children}
        </Modal>
    );
};

export default ModalComponent;
